/* ==========================================================================
   catalog-touch.js — Borde táctil en móvil para el product grid.
   Añade la clase .is-touched a la card tocada y la quita de las demás.
   Aislado, sin dependencias, no interfiere con el enlace del producto.
   ========================================================================== */
(function () {
  'use strict';

  // Solo en dispositivos táctiles (no ejecuta nada en desktop puro)
  var isTouch = window.matchMedia('(hover: none)').matches ||
                'ontouchstart' in window;
  if (!isTouch) return;

  var grid = document.getElementById('product-grid');
  if (!grid) return;

  function clearAll(except) {
    var active = grid.querySelectorAll('.card-wrapper.is-touched');
    for (var i = 0; i < active.length; i++) {
      if (active[i] !== except) active[i].classList.remove('is-touched');
    }
  }

  // Al tocar un producto, marca su card y desmarca el resto.
  // Usamos touchstart en modo pasivo: NO llama a preventDefault,
  // por lo que el tap sigue navegando al producto con normalidad.
  grid.addEventListener('touchstart', function (e) {
    var card = e.target.closest('.card-wrapper');
    if (!card) {
      clearAll(null);
      return;
    }
    clearAll(card);
    card.classList.add('is-touched');
  }, { passive: true });

  // Si el usuario toca fuera del grid, limpia la selección visual.
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('#product-grid')) clearAll(null);
  }, { passive: true });
})();